import CreditCardForm from "/components/CreditCardForm/CreditCardForm";

export default CreditCardForm;
